<template>
<footer id="new-footer">
    <div class="new-inrContent d-flex">
        <figure class="logo-wrap"><img src="@/assets/new_images/f-logo.png" alt="휴식 로고"></figure>
        <div class="footer-content">
            <ul class="footer-info-wrap">
                <li class="footer-info-list">상호명 : 주식회사 휴식&nbsp;|&nbsp;</li>
                <li class="footer-info-list">대표 : 김환종&nbsp;|&nbsp;</li>
                <li class="footer-info-list">사업자 등록번호 : 646-86-01056</li>
                <!-- <li class="footer-info-list add"><span>주소 : </span>서울특별시 노원구 공릉동 동일로 174길 27 <br class="mBr"> 서울창업디딤터 309호</li> -->
                <li class="footer-info-list add"><span>주소 : </span>서울틀별시 중랑구 면목로 92라길 7-6 <br class="mBr"> YMS타워 D동 2층</li>
                <li class="footer-info-list">이메일 : official@huesik.co.kr&nbsp;|&nbsp; <br class="mBr"> <span @click="moveToPolicy">고시락 이용약관</span></li>
            </ul>
            <p class="copy">Copyright HUESIK All Right Reserved</p>
        </div>
    </div>
</footer>
</template>

<script>
export default {
    methods: {
        moveToPolicy() {
            window.open('https://kosirock.com/policy')
        }
    }
}
</script>
